import React from 'react';
import PropTypes from 'prop-types';
import AuthHeader from 'components/AuthHeader';
import CloseButton from 'components/CloseButton';
import './AuthWrapper.css';

function AuthWrapper({
  children,
  onClose,
  onBack,
  closeUrl,
  logoName,
  ...rest
}) {
  return (
    <div className="auth-container" role="region" {...rest}>
      <div className="auth-wrapper">
        {(onClose || closeUrl) && (
          <CloseButton url={closeUrl} onClick={onClose} />
        )}
        <AuthHeader logoName={logoName} onBack={onBack} />
        <div className="auth">{children}</div>
      </div>
    </div>
  );
}

AuthWrapper.propTypes = {
  children: PropTypes.any,
  closeUrl: PropTypes.string,
  onBack: PropTypes.func,
  onClose: PropTypes.func
};

export default AuthWrapper;
